import { ElementRef, Injectable } from '@angular/core';

// export interface PdfOptions {
// 	scale?: number;
// 	orientation?: 'portrait' | 'landscape';
// 	format?: 'a4' | 'letter' | 'legal';
// 	margin?: number;
// }

@Injectable({
	providedIn: 'root'
})
export class PdfService {
	async exportPdf(name: string, heading: string|undefined, element: ElementRef): Promise<void> {
		const html2canvas = (await import('html2canvas')).default;
		const { jsPDF } = await import('jspdf');

		const scale = 1;
		const orientation = 'portrait';
		const format = 'a4';
		const margin = 10;

		// Capture the element
		const canvas = await html2canvas(element.nativeElement, {
			scale: 2,
			useCORS: true,
			logging: false,
			windowWidth: element.nativeElement.scrollWidth
		});

		const imgData = canvas.toDataURL('image/png');

		const pdf = new jsPDF(orientation, 'mm', format);
		const pageWidth = pdf.internal.pageSize.getWidth();
		const pageHeight = pdf.internal.pageSize.getHeight();

		const contentWidth = pageWidth - (margin * 2);
		const contentHeight = pageHeight - (margin * 2);

		// Calculate dimensions with zoom scale
		const imgWidth = canvas.width;
		const imgHeight = canvas.height;
		const ratio = Math.min(contentWidth / imgWidth, contentHeight / imgHeight) * scale;

		const finalWidth = imgWidth * ratio;
		const finalHeight = imgHeight * ratio;

		// Center on page
		const x = margin + (contentWidth - finalWidth) / 2;
		const y = margin;


		let yOffset = margin;

		// Add heading if provided
		if (heading) {
			pdf.setFontSize(18);
			pdf.setFont('helvetica', 'bold');
			pdf.text(heading, pageWidth / 2, yOffset + 5, { align: 'center' });
			yOffset += 10; // leave space below heading
		}


		pdf.addImage(imgData, 'PNG', x, yOffset, finalWidth, finalHeight);
		pdf.save(`${name}.pdf`);
	}
}
